module.exports = __webpack_public_path__ + "img/zerocarbon2.a5890c94.png";